/**
 * Collapse a request URL to a low-cardinality route for use as a telemetry facet: a raw url gives
 * `p95 by url` one sample per row, not a percentile per endpoint. Origin and query are dropped so an
 * endpoint reads the same across dev1/staging/prod. DI-free, like `classifyHttpFailure`.
 */
export function urlTemplate(url: string | undefined | null): string {
  if (!url) return UNKNOWN;

  const path = pathOf(url);
  if (path === null) return UNKNOWN;

  const segments = path.split('/').map(segment => (isIdentifier(segment) ? ':id' : segment));
  // Drop a trailing slash, so `/Headlines` and `/Headlines/` are not two routes.
  const normalized = segments.join('/').replace(/\/$/, '');

  return normalized || '/';
}

const UNKNOWN = 'unknown';

const MONGO_OBJECT_ID = /^[0-9a-f]{24}$/i;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NUMERIC = /^\d+$/;

function isIdentifier(segment: string): boolean {
  return MONGO_OBJECT_ID.test(segment) || UUID.test(segment) || NUMERIC.test(segment);
}

/** Requests here always have an absolute url, so a parse failure is a real anomaly. */
function pathOf(url: string): string | null {
  try {
    return new URL(url).pathname;
  } catch {
    return null;
  }
}
